import {Select, Divider, Input} from "../../__snowpack__/pkg/antd.js";
import {PlusOutlined} from "../../__snowpack__/pkg/@ant-design/icons.js";
import React, {useState} from "../../__snowpack__/pkg/react.js";
import {omit} from "../../__snowpack__/pkg/lodash.js";
const {Option} = Select;
export const SelectInput3 = (props) => {
  const [state, setState] = useState({
    items: [...props.options],
    name: ""
  });
  const onNameChange = (event) => {
    setState({
      ...state,
      name: event.target.value
    });
  };
  const addItem = () => {
    const {items: items2, name: name2} = state;
    if (!name2) {
      return;
    }
    const sameString = items2.filter((itemName) => {
      return itemName.label.toLocaleLowerCase() === name2.toLocaleLowerCase();
    });
    if (sameString && sameString.length > 0) {
      props.onChange(sameString[0].value);
      return false;
    }
    setState({
      items: [
        ...items2,
        {
          label: name2,
          value: name2
        }
      ],
      name: ""
    });
  };
  const {items, name} = state;
  return /* @__PURE__ */ React.createElement(Select, {
    showSearch: true,
    optionFilterProp: "title",
    placeholder: props.placeholder,
    dropdownRender: (menu) => /* @__PURE__ */ React.createElement("div", null, menu, /* @__PURE__ */ React.createElement(Divider, {
      style: {margin: "4px 0"}
    }), /* @__PURE__ */ React.createElement("div", {
      style: {display: "flex", flexWrap: "nowrap", padding: 8}
    }, /* @__PURE__ */ React.createElement(Input, {
      style: {flex: "auto"},
      value: name,
      placeholder: props.pleaseEnterMsg,
      onChange: onNameChange,
      onKeyDown: (event) => {
        event.stopPropagation();
      }
    }), /* @__PURE__ */ React.createElement("a", {
      style: {
        flex: "none",
        padding: "8px",
        display: "block",
        cursor: "pointer"
      },
      onClick: addItem
    }, /* @__PURE__ */ React.createElement(PlusOutlined, null), " ", props.addAttributeValueMsg))),
    ...omit(props, "options")
  }, items.map((item) => /* @__PURE__ */ React.createElement(Option, {
    key: item.value,
    value: item.value,
    title: item.label
  }, item.label)));
};
